// src/components/SelecaoVariacoes.js
import { useId } from 'react';
import { obterGruposVariacao, obterIdSecaoVariacao, selecionarItemVariacao } from '../utils/VariacaoUtils';
import { formatCurrency } from '../utils/numberUtils';

export default function SelecaoVariacoes({
  produto, escolhas = [], erros = {}, onChange, modo = 'lista', onRegistrarSecao
}) {
  const instanciaId = useId();

  return obterGruposVariacao(produto).map(grupo => {
    const nome = grupo.variacao?.descricao || 'Variação';
    const escolha = escolhas.find(v => Number(v.variacaoId) === Number(grupo.variacaoId));
    const erro = erros[grupo.variacaoId];
    const tituloId = instanciaId + '-titulo-' + grupo.variacaoId;
    const ajudaId = instanciaId + '-ajuda-' + grupo.variacaoId;
    const erroId = instanciaId + '-erro-' + grupo.variacaoId;
    const alterarEscolha = valor => onChange(selecionarItemVariacao(produto, escolhas, grupo.variacaoId, valor));

    if (modo === 'cartoes') {
      return (
        <section
          key={grupo.variacaoId}
          ref={elemento => onRegistrarSecao?.(grupo.variacaoId, elemento)}
          data-section-id={obterIdSecaoVariacao(grupo.variacaoId)}
          className={'item-details-section item-details-variation-section scrollTargetSection' + (erro ? ' is-error' : '')}
          aria-labelledby={tituloId}
          tabIndex={-1}
        >
          <div className="item-details-variation-heading">
            <h2 id={tituloId}>{nome}</h2>
            <span className="item-details-variation-required">Obrigatório</span>
          </div>
          <p id={ajudaId} className="item-details-variation-hint">Escolha 1 opção.</p>
          <fieldset
            className="item-details-variation-choices"
            aria-labelledby={tituloId}
            aria-describedby={ajudaId + (erro ? ' ' + erroId : '')}
          >
            {(grupo.variacao?.variacaoItens || []).map(item => {
              const selecionado = Number(escolha?.variacaoItemId) === Number(item.id);
              return (
                <label key={item.id} className={'item-details-variation-choice' + (selecionado ? ' is-selected' : '')}>
                  <input
                    type="radio"
                    name={instanciaId + '-variacao-' + grupo.variacaoId}
                    value={item.id}
                    checked={selecionado}
                    required
                    aria-invalid={erro ? true : undefined}
                    aria-describedby={erro ? erroId : undefined}
                    onChange={() => alterarEscolha(item.id)}
                  />
                  <span className="item-details-variation-choice-description">{item.descricao}</span>
                  {Number(item.valorAdicional) > 0 && (
                    <span className="item-details-variation-choice-price">+ {formatCurrency(item.valorAdicional)}</span>
                  )}
                </label>
              );
            })}
          </fieldset>
          {erro && <p id={erroId} className="item-details-error-message" role="status">{erro}</p>}
        </section>
      );
    }

    return (
      <section key={grupo.variacaoId} className="item-details-section item-details-select-section">
        <label><strong>{nome}:</strong>
          <select value={escolha?.variacaoItemId || ''}
            onChange={e => alterarEscolha(e.target.value)}
            className={'item-details-select' + (erro ? ' is-error' : '')}>
            <option value="" disabled>Selecione uma opção</option>
            {(grupo.variacao?.variacaoItens || []).map(item => <option key={item.id} value={item.id}>
              {item.descricao}{Number(item.valorAdicional) > 0 ? ' (+' + formatCurrency(item.valorAdicional) + ')' : ''}
            </option>)}
          </select>
        </label>
        {erro && <p className="item-details-error-message">{erro}</p>}
      </section>
    );
  });
}
